import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The Clavian mark (BRAND.md §2): a keyhole held inside an open "C", in its two Eclipse forms (ADR-0060).
 *
 *   flat     the ring in ink, the keyhole in the action red — the console's navigation, receipts, a
 *            favicon, anything small or busy.
 *   eclipse  the ring carries the light of an impact (haze at its base, red through the middle, flare at
 *            its tip) around a keyhole in starlight — hero screens, splash, the kiosk, app icons. On the
 *            dark ground only.
 *
 * Small sizes thicken the strokes so the mark survives 16 and 32 px, as the favicons do. Colours are the
 * tokens, so a venue's accent reaches the keyhole and the ring's middle.
 */
import { useId } from 'react';
import { cx } from '../lib/cx.js';
/** The ring, the same path at every size (64 grid): an open C, opening on the right. */
export const MARK_RING_PATH = 'M48.85 17.85 A22 22 0 1 0 48.85 46.15';
/** The mark's geometry at an optical size: ring stroke, keyhole radius and the slot below it. */
export function markGeometry(size) {
    if (size <= 20)
        return { stroke: 8, radius: 7, slot: 'M28 31.5 h8 l1.5 12 h-11 z' };
    if (size <= 40)
        return { stroke: 7, radius: 6, slot: 'M28.5 31.5 h7 l1.5 12 h-10 z' };
    return { stroke: 6.5, radius: 5.6, slot: 'M28.7 31.5 h6.6 l1.5 12 h-9.6 z' };
}
export function ClavianMark({ variant = 'flat', size = 32, title, className }) {
    const rim = `clav-mark-rim-${useId().replace(/:/g, '')}`;
    const { stroke, radius, slot } = markGeometry(size);
    const eclipse = variant === 'eclipse';
    return (_jsxs("svg", { className: cx('clav-mark', `clav-mark--${variant}`, className), viewBox: "0 0 64 64", width: size, height: size, fill: "none", ...(title === undefined ? { 'aria-hidden': true } : { role: 'img', 'aria-label': title }), children: [eclipse ? (_jsx("defs", { children: _jsxs("linearGradient", { id: rim, x1: "0", y1: "1", x2: "1", y2: "0", children: [_jsx("stop", { offset: "0", className: "clav-mark__stop clav-mark__stop--haze" }), _jsx("stop", { offset: "0.5", className: "clav-mark__stop clav-mark__stop--red" }), _jsx("stop", { offset: "1", className: "clav-mark__stop clav-mark__stop--flare" })] }) })) : null, _jsx("path", { className: "clav-mark__ring", d: MARK_RING_PATH, strokeWidth: stroke, strokeLinecap: "round", ...(eclipse ? { stroke: `url(#${rim})` } : {}) }), _jsxs("g", { className: "clav-mark__keyhole", children: [_jsx("circle", { cx: "32", cy: "27.5", r: radius }), _jsx("path", { d: slot })] })] }));
}
//# sourceMappingURL=mark.js.map